<template>
  <div class="card">
    <NuxtLink
      v-if="posts.content_type"
      :to="{
            name: 'language-blog-id-slug',
            params: {
              language: route.params.language,
              id: posts.id,
              slug: posts.slug,
            },
          }"
    >
      <ContagemRegressivaLive
        :inicio="posts.liveCountdown"
        :capa="posts.cover"
        :largura="isMobile() ? 319 : 393"
        :altura="isMobile() ? 180 : 222"
      >
        <img
          :src="`${posts.cover}`"
          :alt="posts.title"
          :width="isMobile() ? 319 : 393"
          :height="isMobile() ? 180 : 222"
          loading="lazy"
        />
      </ContagemRegressivaLive>
    </NuxtLink>
    <a v-else :href="posts.link_redirect">
      <ContagemRegressivaLive
        :inicio="posts.liveCountdown"
        :capa="posts.cover"
        :largura="isMobile() ? 319 : 393"
        :altura="isMobile() ? 180 : 222"
      >
        <img
          :src="`${posts.cover}`"
          :alt="posts.title"
          :width="isMobile() ? 319 : 393"
          :height="isMobile() ? 180 : 222"
          loading="lazy"
        />
      </ContagemRegressivaLive>
    </a>
    <div class="card-body">
      <NuxtLink
        v-if="posts.content_type"
        :to="{
            name: 'language-blog-id-slug',
            params: {
              language: route.params.language,
              id: posts.id,
              slug: posts.slug,
            },
          }"
      >
        <div :class="props.homepage ? 'card-title' : 'card-title-mobile'">
          {{ props.posts.title }}
        </div>
      </NuxtLink>
      <a v-else :href="props.posts.link_redirect">
        <div :class="props.homepage ? 'card-title' : 'card-title-mobile'">
          {{ props.posts.title }}
        </div>
      </a>

      <p
        class="card-text"
        v-for="description in props.posts.meta_description"
        :key="description.language_id"
      >
        <span
          v-if="description.language_id === 1 && route.params.language === 'pt-br'"
          v-text="description.content"
        ></span>
        <span
          v-if="description.language_id === 2 && route.params.language === 'en'"
          v-text="description.content"
        ></span>
      </p>
      <div class="row" v-if="route.name === 'language-blog'">
        <p class="card-text small col-6" v-if="props.posts.content_type">
          <font-awesome :icon="['far', 'comment-dots']" size="sm" />
          {{ posts.comments }}
          {{ translate.commentsBlog }}
        </p>
        <p class="card-text small col-6">
          <font-awesome :icon="['far', 'clock']" size="sm" />
          {{ posts.date }}
        </p>
      </div>
      <NuxtLink
        v-if="posts.content_type"
        :to="{
            name: 'language-blog-id-slug',
            params: {
              language: route.params.language,
              id: posts.id,
              slug: posts.slug,
            },
          }"
        class="button--more"
      >
        {{ translate.moreBlog }}
        <font-awesome
          :icon="['fas', 'arrow-right']"
          size="sm"
          style="margin-left: 6px"
        />
      </NuxtLink>
      <a v-else :href="posts.link_redirect" class="button--more">
        {{ translate.moreBlog }}
        <font-awesome
          :icon="['fas', 'arrow-right']"
          size="sm"
          style="margin-left: 6px"
        />
      </a>

      <div>&nbsp;</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import translateMain from "@/tradutors/menu";
import { isMobile } from "@/shared/utils/mobile";
import ContagemRegressivaLive from "@/components/Blog/ContagemRegressivaLive.vue";
const route = useRoute();
const props = defineProps(["posts", "homepage"]);
const translate = computed(() =>
  route.params.language === "pt-br"
    ? translateMain.portugues
    : translateMain.ingles
);

</script>
<style scoped>
.card >>> .card-body {
  padding: 5px 0px 0px;
}

.card-body p {
  margin-bottom: 5px;
}
.card-title {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  margin-bottom: 5px;
}

.card-title-mobile {
  color: #b20000;
  font-family: "Roboto-Medium";
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  margin-top: 5px;
  margin-bottom: 10px;
  line-height: 27px;
}

.card-text span {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  display: block;
}

.small {
  color: #5b5858;
  font-family: "Roboto-Regular";
  font-size: 13px;
  letter-spacing: 0;
  margin-bottom: 0px !important;
}
.button--more svg {
  color: #b20000;
}

.button--more {
  height: 19px;
  color: #666666;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: right;
}

.small svg {
  margin-right: 5px;
}

.card img {
  width: 100%;
  object-fit: cover;
  cursor: pointer;
}

/* Contagem regressiva da live no lugar da capa: mesma caixa da imagem. */
.card .contagem-live {
  width: 100%;
  cursor: pointer;
}

.card {
  background-color: var(--bs-white);
  width: 99%;
  color: #5b5858;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {
  .card {
    width: 100%;
  }
  .card-body p {
    margin-bottom: 10px;
  }

  /* altura proporcional à largura: sem isto, a altura do atributo HTML (180px)
     fica fixa enquanto a largura é 100%, espichando a imagem */
  .card img,
  .card .contagem-live {
    height: auto;
  }
}
</style>
